module.exports = __webpack_public_path__ + "static/media/sama2.773d23cc.wav";